// BANDUDU · fecha estimada de entrega en la ficha de producto.
// El proveedor surte en hasta 5 días hábiles y la paquetería tarda de 1 a 5: el cliente recibe en 6 a 10 días hábiles.
// Sin este script el elemento <bd-llegada> conserva su texto: "Llega en 6 a 10 días hábiles".
// Misma cuenta que marketplace/bandudu-mp.js (función habiles): sin sábados, domingos ni festivos.
(() => {
  if (customElements.get("bd-llegada")) return;

  const FESTIVOS = ["2026-11-16", "2026-12-25", "2027-01-01", "2027-02-01", "2027-03-15", "2027-05-01"];
  const DIAS = ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"];
  const MESES = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];
  const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
  const habiles = (n) => {
    const d = new Date();
    for (let k = 0; k < n; ) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() % 6 !== 0 && !FESTIVOS.includes(iso(d))) k++;
    }
    return d;
  };
  const textoLlegada = () => {
    const a = habiles(6);
    const b = habiles(10);
    const mismoMes = a.getMonth() === b.getMonth();
    const inicio = `${DIAS[a.getDay()]} ${a.getDate()}${mismoMes ? "" : ` de ${MESES[a.getMonth()]}`}`;
    return `Llega entre el ${inicio} y el ${DIAS[b.getDay()]} ${b.getDate()} de ${MESES[b.getMonth()]}`;
  };

  class BdLlegada extends HTMLElement {
    connectedCallback() {
      this.poner();
      // Horizon vuelve a pintar la ficha al cambiar de variante; si regresa el texto de respaldo, se corrige.
      this.observador = new MutationObserver(() => this.poner());
      this.observador.observe(this, { childList: true, characterData: true, subtree: true });
    }

    disconnectedCallback() {
      this.observador?.disconnect();
    }

    poner() {
      const texto = textoLlegada();
      if (this.textContent !== texto) this.textContent = texto;
    }
  }

  customElements.define("bd-llegada", BdLlegada);
})();
